import { Box, Dialog, DialogContent, IconButton, styled, Typography } from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    margin: theme.spacing(2),
    borderRadius: theme.spacing(2),
    overflow: "hidden",
    backgroundColor: "#fff",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
  },
}));

export const StyledDialogContent = styled(DialogContent)({
  position: "relative",
  padding: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "#f5f5f5",
});

export const HeaderBox = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 16px",
  backgroundColor: "white",
  borderBottom: "1px solid #e0e0e0",
});

export const StyledTypography = styled(Typography)({
  fontWeight: 500,
  color: "#333",
  flexGrow: 1,
  textAlign: "center",
  marginRight: "16px",
});

export const StyledIconButton = styled(IconButton)({
  color: "#666",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
});

export const ImageContainer = styled(Box)({
  padding: "24px",
  width: "100%",
});

export const StyledImage = styled("img")({
  maxWidth: "100%",
  maxHeight: "100%",
  width: "auto",
  height: "auto",
  objectFit: "contain",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
});
